import React from 'react';
import {
  BrowserRouter as Router, Switch, Redirect, Route,
} from 'react-router-dom';
import AppLayout from '../pages/layout/AppLayout';
import Declare from '../pages/declare';
import Apply from '../pages/apply';
import { UserData, UserProvider } from '../components/UserData';
import List from '../pages/review/List';
import GroupList from '../pages/review/GroupList';
import ProjectList from '../pages/review/ProjectList';
import Detail from '../pages/review/Detail';
import Info from '../pages/review/Info';
import Reference from '../pages/reference';
import Nomination from '../pages/nomination';
import Recommend from '../pages/recommend';
import Preview from '../pages/preview';
import { AuthRoute } from '../components/UserData/AuthRoute';

import './index.scss';

const versions = (function () {
  const u = navigator.userAgent;

  return {
    trident: u.indexOf('Trident') > -1, //IE内核
    presto: u.indexOf('Presto') > -1, //opera内核
    webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, //火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
    iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
    iPad: u.indexOf('iPad') > -1, //是否iPad
    webApp: u.indexOf('Safari') === -1, //是否web应该程序，没有头部与底部
    weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
    qq: u.match(/\sQQ/i) === ' qq', //是否QQ
  };
}());

// 创建路由配置组件，接受基础路径前缀
const RoutesConfig = ({ pathPrefix = '' }) => {
  console.log('pathPrefix', pathPrefix);
  return (
    <Switch>
      {/* 选择申报类型 */}
      <AuthRoute path={`${pathPrefix}/declare`} component={Declare} auth={[2]} />
      {/* TODO: 已废弃？ */}
      <AuthRoute path={`${pathPrefix}/apply/detail`} component={Apply} auth={[2]} />
      {/* 申报页 */}
      <AuthRoute path={`${pathPrefix}/apply/:formType`} component={Apply} auth={[2]} />
      {/* 项目预览页 */}
      <AuthRoute path={`${pathPrefix}/preview`} component={Preview} auth={[2]} />
      {/* TODO: 已废弃？ */}
      <AuthRoute path={`${pathPrefix}/review/list`} component={List} auth={[1]} />
      {/* 评审-分组列表 */}
      <AuthRoute path={`${pathPrefix}/review/groupList`} component={GroupList} auth={[1]} />
      {/* 评审-项目列表 */}
      <AuthRoute path={`${pathPrefix}/review/projectList`} component={ProjectList} auth={[1]} />
      {/* 评审-项目详情 */}
      <AuthRoute path={`${pathPrefix}/review/detail/:projectNo`} component={Detail} auth={[1]} />
      <AuthRoute path={`${pathPrefix}/review/info/:projectNo`} component={Info} auth={[1]} />
      <Redirect from={`${pathPrefix}/review`} exact to={`${pathPrefix}/review/groupList`} />
      <AuthRoute path={`${pathPrefix}/reference`} component={Reference} />
      <AuthRoute path={`${pathPrefix}/nomination/:nominationCode`} component={Nomination} auth={[1, 2, 3]} />
      <AuthRoute path={`${pathPrefix}/recommend/:recommendCode`} component={Recommend} auth={[1, 2, 3]} />
      <AuthRoute path={`${pathPrefix}/`} exact={false} auth={null} requireLogin={false}>
        <AppLayout pathPrefix={pathPrefix} />
      </AuthRoute>
      <Redirect from={`${pathPrefix}*`} to={`${pathPrefix}/home`} />
    </Switch>
  );
};

const App = () => {
  React.useEffect(() => {
    if (versions.ios || versions.android || versions.mobile) {
      window.location.href = `${window.location.origin}/h5`;
    }
  }, []);

  return (
    <div className="app">
      <Router>
        <UserData redirect={false}>
          <Switch>
            {/* 带 /v2 前缀的路由配置 */}
            <Route path="/v2" exact={false}>
              <RoutesConfig pathPrefix="/v2" />
            </Route>
            {/* 默认路径前缀为空的路由配置 */}
            <Route path="/" exact={false}>
              <RoutesConfig pathPrefix="" />
            </Route>
          </Switch>
        </UserData>
      </Router>
    </div>
  );
};

export default () => (
  <UserProvider value={{}}>
    <App />
  </UserProvider>
);
